<template>
	<div>
		<commonHeader />
		<div v-if="nowWidth > 784">
			<div class="portfolio_1">
				<v-img src="/image/portfolio_1.png" class="px-pc">
					<div class="about_1_text">
						Our Portfolio
					</div>
					<v-layout>
						<v-layout class="tab-css-2">
							<v-flex v-for="(tab, i) in $store.state.tabList" :key="i" class="pr-8" style="flex: 1; max-width: 20%;">
								<v-flex xs12>
									<v-divider dark class="main-hr-1 mb-4"></v-divider>
								</v-flex>
								<div>
									<div class="number mr-2">0{{ i + 1 }}</div>
									<div class="Title" @click="titleGoto(tab.link)">
										{{ tab.title }}
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-layout>
				</v-img>
			</div>
			<div class="px-pc portfolio_layout">
				<v-layout wrap>
					<v-flex xs3 v-for="(list, i) in portfolios" :key="i" class="mb-5 pr-5">
						<div class="cursor" @click="clickPortfolio(list, i)">
							<v-img width="300" height="auto" contain :src="'/image/' + list.link"></v-img>
						</div>
					</v-flex>
				</v-layout>
			</div>
			<div class="portfolio_2">
				<v-img contain src="/image/portfolio_2.png"></v-img>
			</div>
		</div>
		<div v-else>
			<div class="m_portfolio_1">
				<v-img width="100%" src="/image/m_portfolio_1.png" class="pl-6">
					<div class="m_about_1_text">
						Our Portfolio
					</div>
				</v-img>
			</div>
			<v-layout class="m_contact_layout">
				<hr class="m_divider_4" />
				<v-layout wrap class="m_portfolio_layout">
					<v-flex
						xs6
						v-for="(list, i) in portfolios"
						:key="i"
						:class="i === portfolios.length - 1 || i === portfolios.length - 2 ? 'pr-5' : 'mb-5 pr-5'"
					>
						<div class="cursor" @click="clickPortfolio(list, i)">
							<v-img width="100%" height="auto" contain :src="'/image/' + list.link"></v-img>
						</div>
					</v-flex>
				</v-layout>
			</v-layout>
			<div class="mt-10">
				<v-img contain src="/image/m_portfolio_2.png"></v-img>
			</div>
		</div>
		<v-dialog v-model="selectPortfolio.dialog" :max-width="nowWidth > 784 ? '65%' : '85%'" content-class="dialog-portfolio">
			<div v-if="nowWidth > 784">
				<div class="dialog-close" @click="selectPortfolio.dialog = false">
					<v-img width="39" height="39" contain :src="'/image/closeIcon.png'"></v-img>
				</div>
				<v-layout class="dialog-layout">
					<div>
						<v-img style="background-color: white;" width="300" height="auto" contain :src="'/image/' + selectPortfolio.link"></v-img>
					</div>
					<div class="dialog-content">
						<div class="port-title">{{ selectPortfolio.title }}</div>
						<div class="port-content">{{ selectPortfolio.content }}</div>
					</div>
				</v-layout>
			</div>
			<div v-else>
				<div class="dialog-close" @click="selectPortfolio.dialog = false">
					<v-img width="39" height="39" contain :src="'/image/closeIcon.png'"></v-img>
				</div>
				<v-layout class="dialog-layout">
					<div style="width: -webkit-fill-available;">
						<v-img contain height="auto" :src="'/image/' + selectPortfolio.link"></v-img>
					</div>
				</v-layout>
				<div class="m_dialog-content">
					<div class="port-title">{{ selectPortfolio.title }}</div>
					<div class="port-content">{{ selectPortfolio.content }}</div>
				</div>
			</div>
		</v-dialog>
		<commonFooter />
	</div>
</template>
<script>
import { commonHeader, commonFooter } from '@/components/index'
export default {
	name: 'portfolio',
	components: {
		commonHeader,
		commonFooter,
	},
	data() {
		return {
			screenWidth: window.innerWidth,
			selectPortfolio: {
				dialog: false,
				title: '',
				content: '',
				link: '',
			},
			portfolios: [
				{
					title: '퓨리오사AI (퍼시픽-엠제이엠 인공지능(AI) 반도체 제2호 신기술투자조합, 레오 14호 퓨리오사펀드)',
					content: '■ 사업요약\n- AI 워크로드 특화 NPU 칩셋 개발',
					link: '46_portfolio.jpg',
				},
				{
					title: '엑시나 (원익 2026CXL 투자조합)',
					content: '■ 사업요약\n- CXL 기반 데이터 처리 가속기 개발',
					link: '45_portfolio.jpg',
				},
				{
					title: '퓨리오젠(주) (패스웨이-유아이엘 신기술조합 제2호)',
					content: '■ 사업요약\n- 바이오의약품 정제용 크로마토그래피 레진 생산',
					link: '44_portfolio.jpg',
				},
				{
					title: '리벨리온 (미래에셋 딥테크 로켓 투자조합)',
					content: '■ 사업요약\n- AI 추론 연산 특화 칩 및 소프트웨어 설계 개발',
					link: '38_portfolio.jpg',
				},
				{
					title: '(주)미메틱스',
					content: '■ 사업요약\n- 생체모사 기반 음압 패치 기술 기업',
					link: '40_portfolio.jpg',
				},
				{
					title: '(주)플라잎',
					content: '■ 사업요약\n- AI 기반 양팔 로봇 자동화 솔루션 기업',
					link: '39_portfolio.jpg',
				},
				{
					title: '(주)피코팩',
					content: `■ 사업요약\n- 디지털 엑스선 튜브, ACG 모듈, 고전압 파워 통합형 '지능형 디지털 엑스레이 모노블럭' 제조`,
					link: '41_portfolio.jpg',
				},
				{
					title: '(주)비스툴',
					content: `■ 사업요약\n- 3D 맞춤형 코 성형 보형물 전문 기업`,
					link: '43_portfolio.jpg',
				},
				{
					title: '(주)닥터트루',
					content: `■ 사업요약\n- 맞춤형 대체 감미료 개발 업체`,
					link: '42_portfolio.jpg',
				},
				{ title: '솔라라이즈㈜', content: '■ 사업요약\n- 지능형 태양광 인버터 회사', link: '36_portfolio.jpg' },
				{
					title: '㈜솔리온',
					content: '■ 사업요약\n- 폐배터리, 셀ㆍ모듈ㆍ팩, 양극재와 음극재 Foil 리사이클링 기업',
					link: '34_portfolio.jpg',
				},
				{
					title: '㈜아이벡스메디칼시스템즈',
					content: '■ 사업요약\n- 고압산소치료기 전문 제조사',
					link: '33_portfolio.jpg',
				},
				{
					title: '㈜글라우드',
					content: "■ 사업요약\n- 디지털 보철 솔루션 '저스트스캔 익스프레스(JSE)'",
					link: '32_portfolio.jpg',
				},
				{
					title: '㈜재영텍',
					content: '■ 사업요약\n- 배터리용 고순도 탄산리튬을 Closed Loop System 기반 사용후 이차전지에서 양산',
					link: '31_portfolio.jpg',
				},
				{
					title: '㈜솔룸신소재',
					content: '■ 사업요약\n- 등주속비대칭압연(ESAR) 기술을 활용한 소재 개발',
					link: '30_portfolio.png',
				},
				{
					title: '㈜브레이크앤컴퍼니',
					content: '■ 사업요약\n- 트레이딩 카드 유통 및 그레이딩 서비스',
					link: '29_portfolio.png',
				},
				{
					title: '(주)리클',
					content: '■ 사업요약\n- 헌옷 수거 및 판매 서비스',
					link: '28_portfolio.png',
				},
				{
					title: '벨루가브루어리㈜',
					content: '■ 사업요약\n- 주류 유통의 디지털화 및 영업 솔루션/물류 풀필먼트 서비스',
					link: '27_portfolio.png',
				},
				{
					title: '(주)케이비엘러먼트',
					content: '■ 사업요약\n- 비산화 그래핀 원재료 및 응용제품',
					link: '26_portfolio.png',
				},
				{
					title: '(주)씨엘모빌리티',
					content: '■ 사업요약\n- 수요응답형 모빌리티 서비스(DRT) 및 민간 고객사 대상 MaaS 서비스',
					link: '25_portfolio.png',
				},
				{
					title: '페리지에어로스페이스㈜',
					content: '■ 사업요약\n- 액체연료 기반 지구저궤도(LEO)상 소형위성 등 발사 서비스',
					link: '24_portfolio.png',
				},
				{
					title: '(주)튜링',
					content: `■ 사업요약\n- AI 수학교육 서비스 '수학대왕'`,
					link: '23_portfolio.png',
				},
				{
					title: '(주)지놈포미',
					content: `■ 사업요약\n- 전장유전체분석(Whole genome sequencing, WGS)을 통한 암 환자 유전적 돌연변이 검출 및 개인 맞춤형 암 정밀 의료 서비스`,
					link: '22_portfolio.png',
				},
				{
					title: 'ZERO X AND PTE. LTD.',
					content: '■ 사업요약\n- NFT 게임사 대상 프레임 워크 및 Web3멀티 체인에 적용 가능한 NFT 렌탈 솔루션',
					link: '20_portfolio.png',
				},
				{
					title: '(주)지투이',
					content:
						'■ 사업요약\n- 스마트 인슐린 펜, 세계 최초 PLGS 기능 탑재 인슐린 펌프, 병원/환자/보호자 케어 가능한 당뇨 플랫폼 기반 디지털 당뇨케어',
					link: '21_portfolio.png',
				},
				{
					title: '㈜이그니스',
					content: '■ 사업요약\n- FMCG 및 Beauty 브랜드 마케팅 및 탄산/알코올의 재밀봉을 가능하게 하는 Resealable Lid 개발',
					link: '18_portfolio.png',
				},
				{ title: '모비어스㈜', content: '■ 사업요약\n- 자율주행 물류 로봇 및 솔루션', link: '35_portfolio.jpg' },
				{ title: '㈜지놈앤컴퍼니', content: '■ 사업요약\n- 마이크로바이옴 및 신규 타겟 기반 항암제 개발', link: '17_portfolio.png' },
				{
					title: '㈜페르세우스',
					content: '■ 사업요약\n- Hypervisor 가상화 기술을 통한 SDV향 platform 기반 구현과 차량용 반도체(Chip) 부족 및 보안취약성을 해결',
					link: '16_portfolio.png',
				},
				{
					title: '㈜뮤즈라이브',
					content:
						'■ 사업요약\n- CD, Vinyl(LP)이후 최초로 글로벌 차트에 음반으로 집계되는 KiT Album 및 비용 없이 앨범을 출시할 수 있는 Platform 서비스 KiTbetter',
					link: '15_portfolio.png',
				},
				{
					title: '㈜유씨아이테라퓨틱스',
					content: '■ 사업요약\n- CAR-NK 기반 고형암 치료제 및 이중 타겟팅 가능한 플랫폼 기술을 통한 TME 제어',
					link: '14_portfolio.png',
				},
				{
					title: '㈜모토브',
					content: '■ 사업요약\n- 택시탑미디어 광고, 모빌리티 디지털 광고 및 도시데이터 플랫폼',
					link: '13_portfolio.png',
				},
				{
					title: '㈜케이셀바이오사이언스',
					content: '■ 사업요약\n- 무혈청/화학조성/맞춤형 배지를 통한 백신, 줄기세포, 배양육, 식품용 등 다양한 영역에 세포배양배지',
					link: '12_portfolio.png',
				},
				{ title: '원큐어젠㈜', content: '■ 사업요약\n- 펩타이드 항암제 개발기술, 약물 개발기술, 약물 전달기술', link: '11_portfolio.png' },
				{ title: '㈜인비즈', content: '■ 사업요약\n- 의료·정밀·시계·광학기기', link: '10_portfolio.png' },
				{ title: '㈜테라바이오', content: '■ 사업요약\n- 친환경 대용량 음식물처리기 제조', link: '09_portfolio.png' },
				{ title: '㈜칸젠', content: '■ 사업요약\n- 보톨리늄 톡신을 활용한 의약품 및 화장품 제조', link: '08_portfolio.png' },
				{ title: '㈜넥서스비', content: '■ 사업요약\n- 반도체 및 디스플레이 증착장비 제조', link: '07_portfolio.png' },
				{ title: '㈜피엠아이바이오텍', content: '■ 사업요약\n- 어패류 폐기물 활용 탄산칼슘 제조', link: '06_portfolio.png' },
				{ title: '㈜리베스트', content: '■ 사업요약\n- 축전지 제조', link: '05_portfolio.png' },
				{
					title: '㈜크레셈',
					content: '■ 사업요약\n- 반도체공정관련장비, ACF본딩장비 제조',
					link: '04_portfolio.png',
				},
				{ title: '㈜뉴넥스', content: '■ 사업요약\n- 쇼핑몰,브랜드 운영 대행/소프트웨어 개발,공급', link: '37_portfolio.jpg' },
				{
					title: '㈜컬리',
					content: '■ 사업요약\n- 전자상거래(농산물)',
					link: '01_portfolio.png',
				},
			],
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		clickPortfolio(list, i) {
			this.selectPortfolio.dialog = true
			this.selectPortfolio.title = list.title
			this.selectPortfolio.content = list.content
			const linkArray = this.portfolios.map(portfolio => portfolio.link)
			this.selectPortfolio.link = linkArray[i]
		},
		titleGoto(link) {
			this.$router.push({ name: link })
		},
	},
}
</script>
